import createService from 'shared/utils/createService.js';

export default createService('api/v1/pusher/auth/');
